import React from "react";
import Toggle from "@streeteasy/design-system/legacy/Toggle";
import { useFormikContext } from "formik";
import { bool } from "prop-types";

import useReducerActions from "../../utilities/useReducerActions";
import * as S from "./styled";

const tabItems = [
  {
    text: "Yes",
    value: "yes"
  },
  {
    text: "No",
    value: "no"
  }
];

const BuyerAgentQuestion = ({ isOnLastStep }) => {
  const {
    dispatchSetNextQuestionnaireStep,
    dispatchSetPostSubmitAnswers
  } = useReducerActions();
  const { setFieldError } = useFormikContext();

  const handleToggleItemClick = ({ tabData }) => {
    setFieldError("form_submission", null);

    dispatchSetPostSubmitAnswers({
      has_buyer_agent: tabData.value
    });

    if (!isOnLastStep) {
      dispatchSetNextQuestionnaireStep();
    }

    return false;
  };

  return (
    <>
      <S.Text>Is a real estate agent already helping you buy a home?</S.Text>
      <Toggle onClick={handleToggleItemClick} tabItems={tabItems} />
    </>
  );
};

BuyerAgentQuestion.propTypes = {
  isOnLastStep: bool.isRequired
};

export default BuyerAgentQuestion;
